import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/UI/Button/Button';
import Indication from './Indication';
import Spinner from '../../../components/UI/Spinner/Spinner';

import styles from './Indications.module.css';

const Indications = (props) => {
  const navigate = useNavigate();

  const createIndicationHandler = () => {

  }

  const content = props.indications 
                  ? props.indications.map(m => <Indication key={m.id} indication={m} />)
                  : <div style={{height: '60px'}}> <Spinner /> </div>

  return <>
    <div className={styles.indications} >
      <h3 style={{ textAlign: 'center' }}>Befunde</h3>
      {content}
      <Button className={styles.button}
        clicked={ e => {navigate( '/submit/new' )}}
      >
        Neuer Befund
      </Button>
    </div>
  </>
}

export default Indications;